<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import { useAuthStore } from '@/stores/auth'
import { useConventionStore } from '@/stores/convention'

// Bootstrap the global convention/auth context once on app load. Chrome is chosen by route:
// /admin routes get the admin chrome; otherwise the public Broadsheet sheet.
const auth = useAuthStore()
// Public convention identity (dates/edition) for the masthead + fact rail + footer.
const conventionStore = useConventionStore()
const route = useRoute()

onMounted(async () => {
  void conventionStore.load()
  await auth.loadMe()
})

const layout = computed(() => {
  if (route.path.startsWith('/admin')) return AdminLayout
  return DefaultLayout
})
</script>

<template>
  <component :is="layout">
    <RouterView />
  </component>
</template>
